import { Link } from "react-router-dom";
import { Logo } from "@/components/PublicNav";

export default function Footer() {
  return (
    <footer className="dk-raised mt-24 border-t" data-testid="site-footer">
      <div className="dk-container py-12 grid gap-8 md:grid-cols-4">
        <div className="space-y-3">
          <Logo />
          <p className="text-sm" style={{ color: "var(--text-muted)" }}>
            A calm, parent-only guide to your child's world. Guidance, not therapy.
          </p>
        </div>
        <div>
          <h4 className="font-sans font-semibold text-sm mb-3">Product</h4>
          <ul className="space-y-2 text-sm" style={{ color: "var(--text-muted)" }}>
            <li><Link className="hover:text-[#B04A39]" to="/features">Features</Link></li>
            <li><Link className="hover:text-[#B04A39]" to="/pricing">Pricing</Link></li>
            <li><Link className="hover:text-[#B04A39]" to="/faq">FAQ</Link></li>
          </ul>
        </div>
        <div>
          <h4 className="font-sans font-semibold text-sm mb-3">Safety &amp; Legal</h4>
          <ul className="space-y-2 text-sm" style={{ color: "var(--text-muted)" }}>
            <li><Link className="hover:text-[#B04A39]" to="/safety">Warning-sign checklists</Link></li>
            <li><Link className="hover:text-[#B04A39]" to="/terms">Terms of Service</Link></li>
            <li><Link className="hover:text-[#B04A39]" to="/privacy">Privacy Policy</Link></li>
            <li><Link className="hover:text-[#B04A39]" to="/cookies">Cookie Policy</Link></li>
            <li><Link className="hover:text-[#B04A39]" to="/disclaimer">AI &amp; Safety Disclaimer</Link></li>
          </ul>
        </div>
        <div>
          <h4 className="font-sans font-semibold text-sm mb-3">Our promise</h4>
          <ul className="space-y-2 text-sm" style={{ color: "var(--text-muted)" }}>
            <li>Parent-only — no child accounts</li>
            <li>Child data encrypted &amp; private</li>
            <li>Not a monitoring tool</li>
          </ul>
        </div>
      </div>
      <div className="dk-container py-6 border-t text-xs flex flex-col sm:flex-row justify-between gap-2" style={{ color: "var(--text-muted)" }}>
        <span>© {new Date().getFullYear()} DecodeKid. Speak their language.</span>
        <span>DecodeKid is guidance, not therapy, medical advice or an emergency service.</span>
      </div>
    </footer>
  );
}
